//迁徙图
import { getDispatcher } from '@/utils/analysisTools/';
import WFSBean from '@/utils/analysisTools/beans/WFSBean';

export default {
    async initLayer(vm, planInfo, planId) {
        const MapView = vm.MapView;

        const result = {};
        const param = this.checkParameter(planInfo);
        if (param) {
            const {
                serviceTypeStart,
                serviceUrlStart,
                serviceLayerStart,
                matchFieldStart,
                showFieldStart,
                valueFieldStart,
                serviceTypeEnd,
                serviceUrlEnd,
                serviceLayerEnd,
                matchFieldEnd,
                showFieldEnd,
            } = param;
            const featuresStart = await this.getFeatures(
                vm,
                serviceTypeStart,
                serviceUrlStart,
                serviceLayerStart
            );
            const featuresEnd = await this.getFeatures(
                vm,
                serviceTypeEnd,
                serviceUrlEnd,
                serviceLayerEnd
            );
            const bounds = this.getBounds(featuresStart.concat(featuresEnd));
            MapView.map.fitBounds(bounds);
            const pts = [];
            for (let i = 0; i < featuresStart.length; i++) {
                const matchValue = featuresStart[i].properties[matchFieldStart];
                const ends = [];
                for (let j = 0; j < featuresEnd.length; j++) {
                    const _matchValue =
                        featuresEnd[j].properties[matchFieldEnd];
                    if (matchValue === _matchValue) {
                        ends.push(featuresEnd[j]);
                    }
                }
                pts.push([featuresStart[i], ends]);
            }
            //线颜色（随机）
            const color = ['#a6c84c', '#ffa022', '#46bee9'];
            const _series = [];
            pts.forEach(line => {
                const datas = [];
                const datas1 = [];
                for (let x = 0; x < line[1].length; x++) {
                    const fromCoord = line[0].geometry.coordinates;
                    const toCoord = line[1][x].geometry.coordinates;
                    if (fromCoord && toCoord) {
                        datas.push({
                            model: 'Twos',
                            planId: planId,
                            fromName: line[0].properties[showFieldStart],
                            toName: line[1][x].properties[showFieldEnd],
                            key: valueFieldStart,
                            value: line[0].properties[valueFieldStart],
                            coords: [fromCoord, toCoord],
                        });
                        datas1.push({
                            name: line[1][x].properties[showFieldEnd],
                            value: toCoord.concat(90),
                        });
                    }
                }
                datas1.push({
                    name: line[0].properties[showFieldEnd],
                    value: line[0].geometry.coordinates.concat(90),
                });
                const colerIndex = Math.floor(Math.random() * 3);
                const _line = {
                    planid: planId,
                    name: line[0].properties[showFieldStart],
                    coordinateSystem: 'GLMap',
                    type: 'lines',
                    zlevel: 2,
                    effect: {
                        show: true,
                        period: 6,
                        trailLength: 0.4,
                        // symbol: planePath,
                        symbol: 'roundRect',
                        symbolSize: 5,
                    },
                    lineStyle: {
                        normal: {
                            color: color[colerIndex],
                            width: 1,
                            opacity: 0.8,
                            curveness: 0.2,
                        },
                    },
                    data: datas,
                };
                const _effect = {
                    planid: planId,
                    name: line[0].properties[showFieldStart],
                    type: 'effectScatter',
                    coordinateSystem: 'GLMap',
                    zlevel: 2,
                    rippleEffect: {
                        brushType: 'stroke',
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'right',
                            formatter: '{b}',
                        },
                    },
                    symbolSize: function (val) {
                        return val[2] / 8;
                    },
                    itemStyle: {
                        normal: {
                            color: color[colerIndex],
                            width: 0,
                            opacity: 0.8,
                        },
                    },
                    data: datas1,
                };
                _series.push(_line, _effect);
            });
            result.info = true;
            result.data = _series;
            return result;
        } else {
            result.info = false;
            return result;
        }
    },
    //检查参数是否完整
    checkParameter(json) {
        try {
            const parameter = {};
            const thematic = json.configcont.thematic;
            parameter.serviceTypeStart = thematic.serviceTypeStart;
            parameter.serviceUrlStart = thematic.serviceUrlStart;
            parameter.serviceLayerStart = thematic.serviceLayerStart;
            parameter.matchFieldStart = thematic.matchFieldStart;
            parameter.showFieldStart = thematic.showFieldStart;
            parameter.valueFieldStart = thematic.valueFieldStart;
            parameter.serviceTypeEnd = thematic.serviceTypeEnd;
            parameter.serviceUrlEnd = thematic.serviceUrlEnd;
            parameter.serviceLayerEnd = thematic.serviceLayerEnd;
            parameter.matchFieldEnd = thematic.matchFieldEnd;
            parameter.showFieldEnd = thematic.showFieldEnd;
            for (const values of Object.values(parameter)) {
                if (values === undefined) {
                    return false;
                }
            }
            return parameter;
        } catch {
            return false;
        }
    },
    async getFeatures(vm, type, url, layer) {
        const queryParams = {
            url: url,
            layerName: layer,
        };
        const bean = new WFSBean(queryParams);
        return new Promise((resolve, reject) => {
            getDispatcher(vm)
                .read(bean)
                .then(result => {
                    const features = result.geojson;
                    const _features = [];
                    for (let i = 0; i < features.length; i++) {
                        if (features[i].geometry.type === 'Point') {
                            _features.push(features[i]);
                        }
                    }
                    resolve(_features);
                })
                .catch(() => {
                    vm.$Message.error('方案数据解析失败，请检查数据配置！');
                    reject();
                });
        });
    },
    getBounds(features) {
        const len = features.length;
        const geometries = new Array(len);
        for (let i = 0; i < len; ++i) {
            geometries[i] = GeoGlobe.Feature.fromGeoJson(
                features[i]
            )[0].geometry;
        }
        const geom = new GeoGlobe.Geometry.Collection(geometries);
        geom.calculateBounds();
        return geom.bounds;
    },
};
